module.exports = __webpack_public_path__ + "img/image_011.b9c536c3.jpg";